/**
 * API 接口层
 * 接口规范：api/{模块}/{资源}/{操作}
 */
import request from '@/utils/request'

export default request

// ==================== 认证 ====================

/** 管理员登录 */
export function login(data) {
  return request.post('/admin/auth/login', data)
}

// ==================== 壁纸管理 ====================

/** 获取壁纸列表 */
export function getWallpapers(params) {
  return request.get('/admin/wallpaper/getWallpaperPage', { params })
}

/** 获取Banner列表 */
export function getBanners() {
  return request.get('/admin/wallpaper/bannerList')
}

/** 设为/取消Banner */
export function toggleBanner(id) {
  return request.put('/admin/wallpaper/toggleBanner', { id })
}

/** 移除Banner */
export function removeBannerApi(payload) {
  return request.put('/admin/wallpaper/toggleBanner', { id: payload.wallpaperId })
}

/** 添加Banner */
export function addBanner(payload) {
  return request.put('/admin/wallpaper/toggleBanner', { id: payload.wallpaperId })
}

/** Banner排序 */
export function sortBanners(ids) {
  return request.put('/admin/wallpaper/bannerSort', { ids })
}

/** 批量删除壁纸 */
export function batchDeleteWallpapers(ids) {
  return request.post('/admin/wallpaper/batchDelete', { ids })
}

export function batchFeaturedWallpapers(ids, isFeatured) {
  return request.post('/admin/wallpaper/batchFeatured', { ids, is_featured: isFeatured })
}

/** 批量上下架壁纸 */
export function batchToggleWallpaperStatus(ids, status, reason) {
  return request.post('/admin/wallpaper/batchToggleStatus', { ids, status, reason })
}

/** 壁纸概览统计 */
export function getWallpaperStats() {
  return request.get('/admin/wallpaper/getStats')
}

/** 壁纸上下架 */
export function toggleWallpaperStatus(id, reason) {
  return request.put('/admin/wallpaper/toggleStatus', { id, reason })
}

/** 新增壁纸 */
export function createWallpaper(data) {
  return request.post('/admin/wallpaper/add', data)
}

/** 编辑壁纸 */
export function updateWallpaper(id, data) {
  return request.put('/admin/wallpaper/update', { id, ...data })
}

/** 删除壁纸 */
export function deleteWallpaper(id) {
  return request.delete('/admin/wallpaper/delete', { params: { id } })
}

// ==================== 投稿审核 ====================

/** 获取审核列表 */
export function getReviews(params) {
  return request.get('/admin/submission/getSubmissionPage', { params })
}

/** 通过审核 */
export function approveSubmission(id) {
  return request.post('/admin/submission/approve', { id })
}

/** 驳回投稿 */
export function rejectSubmission(id, reason) {
  return request.post('/admin/submission/reject', { id, reason })
}

// ==================== 用户管理 ====================

/** 获取用户列表 */
export function getUsers(params) {
  return request.get('/admin/user/getUserPage', { params })
}

/** 获取用户详情 */
export function getUserDetail(id) {
  return request.get('/admin/user/detail', { params: { id } })
}

/** 启用/禁用用户 */
export function toggleUserStatus(id) {
  return request.put('/admin/user/toggleStatus', { id })
}

// ==================== 仪表盘 ====================

/** 获取仪表盘数据 */
export function getDashboardData() {
  return request.get('/admin/dashboard/getStatisticsData')
}

// ==================== 分类管理 ====================

/** 获取分类列表 */
export function getCategories() {
  return request.get('/admin/category/getCategoryData')
}

/** 新增分类 */
export function createCategory(data) {
  return request.post('/admin/category/add', data)
}

/** 编辑分类 */
export function updateCategory(id, data) {
  return request.put('/admin/category/update', { id, ...data })
}

/** 删除分类 */
export function deleteCategory(id) {
  return request.delete('/admin/category/delete', { params: { id } })
}

// ==================== 标签管理 ====================

/** 获取标签列表 */
export function getTags() {
  return request.get('/admin/tag/getTagData')
}

/** 标签概览统计 */
export function getTagStats() {
  return request.get('/admin/tag/getStats')
}

/** 新增标签 */
export function createTag(data) {
  return request.post('/admin/tag/add', data)
}

/** 编辑标签 */
export function updateTag(id, data) {
  return request.put('/admin/tag/update', { id, ...data })
}

/** 删除标签 */
export function deleteTag(id) {
  return request.delete('/admin/tag/delete', { params: { id } })
}

// ==================== 盲盒文案管理 ====================

/** 获取文案列表 */
export function getQuotes(params) {
  return request.get('/admin/quote/getQuoteData', { params })
}

/** 新增文案 */
export function createQuote(data) {
  return request.post('/admin/quote/add', data)
}

/** 编辑文案 */
export function updateQuote(data) {
  return request.put('/admin/quote/update', data)
}

/** 删除文案 */
export function deleteQuote(id) {
  return request.delete('/admin/quote/delete', { params: { id } })
}

// ==================== 广告管理 ====================

/** 获取广告配置 */
export function getAdConfigs() {
  return request.get('/admin/advert/list')
}

/** 获取广告统计 */
export function getAdStatistics() {
  return request.get('/admin/advert/stats')
}

/** 更新广告配置 */
export function updateAdConfig(id, data) {
  return request.put('/admin/advert/update', { id, ...data })
}

// ==================== 系统设置 ====================

/** 获取系统设置 */
export function getSettings() {
  return request.get('/admin/setting/list')
}

/** 保存系统设置 */
export function saveSettings(payload) {
  const { type, data } = payload
  return request.put('/admin/setting/save', { group: type, settings: data })
}

// ==================== 管理员管理 ====================

/** 获取管理员列表 */
export function getAdminUsers() {
  return request.get('/admin/manager/list')
}

/** 新增/编辑管理员 */
export function saveAdminUser(payload) {
  const { isEdit, data } = payload
  if (isEdit) {
    return request.put('/admin/manager/update', data)
  }
  return request.post('/admin/manager/add', data)
}

/** 重置管理员密码 */
export function resetAdminPassword(id, password) {
  return request.put('/admin/manager/resetPassword', { id, password })
}

/** 删除管理员 */
export function deleteAdminUser(payload) {
  return request.delete('/admin/manager/delete', { params: { id: payload.id || payload.username } })
}

/** 获取当前管理员信息 */
export function getAdminInfo() {
  return request.get('/admin/auth/info')
}

/** 更新当前管理员个人资料 */
export function updateAdminProfile(data) {
  return request.put('/admin/manager/updateProfile', data)
}

/** 修改当前管理员密码 */
export function changeAdminPassword(data) {
  return request.put('/admin/manager/changePassword', data)
}

// ==================== 操作日志 ====================

/** 获取操作日志列表 */
export function getOperationLogs(params) {
  return request.get('/admin/operationLog/getOperationLogPage', { params })
}

/** 批量删除操作日志 */
export function cleanOperationLogs(ids) {
  return request.post('/admin/operationLog/clean', { ids })
}

// ==================== 意见反馈 ====================

/** 获取反馈列表 */
export function getFeedbacks(params) {
  return request.get('/admin/feedback/getFeedbackPage', { params })
}

/** 标记反馈已处理 */
export function resolveFeedback(id, reply) {
  return request.put('/admin/feedback/resolve', { id, reply })
}

/** 不予处理反馈 */
export function rejectFeedback(id, rejectReason) {
  return request.put('/admin/feedback/reject', { id, rejectReason })
}

/** 删除反馈 */
export function deleteFeedback(id) {
  return request.delete('/admin/feedback/delete', { params: { id } })
}

// ==================== 举报管理 ====================

/** 获取举报列表 */
export function getReports(params) {
  return request.get('/admin/report/list', { params })
}

/** 处理举报（下架壁纸 / 忽略） */
export function processReport(id, action, result) {
  return request.put('/admin/report/process', { id, action, result })
}

// ==================== 公告 ====================

/** 获取公告列表 */
export function getAnnouncements() {
  return request.get('/admin/announcement/list')
}

/** 发布公告 */
export function createAnnouncement(data) {
  return request.post('/admin/announcement/create', data)
}

/** 删除公告（按批次号删除全部用户记录） */
export function deleteAnnouncement(batchId) {
  return request.delete('/admin/announcement/delete', { params: { batchId } })
}

// ==================== 通知（PC端管理员通知） ====================

/** 获取通知列表 */
export function getNotifications(params) {
  return request.get('/admin/notification/list', { params })
}

/** 标记单条通知已读 */
export function markNotificationRead(id) {
  return request.put('/admin/notification/read', { id })
}

/** 全部标记已读 */
export function markAllNotificationsRead() {
  return request.put('/admin/notification/readAll')
}

/** 批量删除通知 */
export function batchDeleteNotifications(ids) {
  return request.post('/admin/notification/batchDelete', { ids })
}

// ==================== 文件上传 ====================

/**
 * 上传图片 */
export function uploadImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/admin/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// ==================== 爬虫入库 ====================

/** 获取爬虫批次列表 */
export function getCrawlerBatches() {
  return request.get('/admin/crawler/batches')
}

/** 获取某批次的图片条目 */
export function getCrawlerItems(batch) {
  return request.get('/admin/crawler/items', { params: { batch } })
}

/** 爬虫图片预览地址（img 标签用，需带 token） */
export function crawlerPreviewUrl(batch, index) {
  const token = localStorage.getItem('token') || ''
  return `${process.env.VUE_APP_API_BASE || process.env.VUE_APP_BASE_API || '/api'}/admin/crawler/preview?batch=${encodeURIComponent(batch)}&index=${index}&token=${encodeURIComponent(token)}`
}

/** 批量入库 */
export function importCrawlerWallpapers(data) {
  return request.post('/admin/crawler/import', data, { timeout: 120000 })
}

/** 触发爬虫（后台执行） */
export function triggerCrawl(data) {
  return request.post('/admin/crawler/crawl', data, { timeout: 30000 })
}

/** 查询爬取任务状态 */
export function getCrawlStatus() {
  return request.get('/admin/crawler/crawl-status')
}

/** 搜索作者（下拉搜索框） */
export function searchCrawlerAuthors(keyword) {
  return request.get('/admin/crawler/authors', { params: { keyword } })
}

// ==================== RBAC 权限管理 ====================

/** 获取所有角色列表 */
export function getRoles() {
  return request.get('/admin/rbac/roles')
}

/** 新增角色 */
export function createRole(data) {
  return request.post('/admin/rbac/roles', data)
}

/** 更新角色 */
export function updateRole(data) {
  return request.put('/admin/rbac/roles', data)
}

/** 删除角色 */
export function deleteRole(id) {
  return request.delete('/admin/rbac/roles', { params: { id } })
}

/** 获取所有权限列表 */
export function getPermissions() {
  return request.get('/admin/rbac/permissions')
}

/** 新增权限 */
export function createPermission(data) {
  return request.post('/admin/rbac/permissions', data)
}

/** 更新权限 */
export function updatePermission(data) {
  return request.put('/admin/rbac/permissions', data)
}

/** 删除权限 */
export function deletePermission(id) {
  return request.delete('/admin/rbac/permissions', { params: { id } })
}

/** 获取角色的权限列表 */
export function getRolePermissions(roleId) {
  return request.get('/admin/rbac/role-permissions', { params: { roleId } })
}

/** 更新角色的权限 */
export function updateRolePermissions(data) {
  return request.put('/admin/rbac/role-permissions', data)
}

/** 获取用户的角色和权限 */
export function getUserPermissions(adminId) {
  return request.get('/admin/rbac/user-permissions', { params: { adminId } })
}

/** 更新用户的角色 */
export function updateUserRoles(data) {
  return request.put('/admin/rbac/user-roles', data)
}